import { env } from 'next-runtime-env'

export const BASE_URL =
  (typeof window === 'undefined'
    ? env('INTERNAL_API_BASE_URL')
    : env('NEXT_PUBLIC_API_BASE_URL')) || process.env.NEXT_PUBLIC_API_BASE_URL
